import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ChartOptions } from 'chart.js';

@Component({
    selector: 'app-line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LineChartComponent implements OnInit {
  @Input() lineChartData: any;
  @Input() xMax = 0;
  @Input() yMax = 0;
  public lineChartOptions: ChartOptions;

  public lineChartLegend = true;
  public lineChartType = 'line';

  ngOnInit() {
    this.lineChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
        },
        title: {
          display: true,
          text: 'THERMAL DRYOUT CURVE',
        },
      },
      scales: {
        x: {
          min: 0,
          max: this.xMax,
          title: {
            display: true,
            text: 'MOISTURE CONTENT (% DRY WEIGHT)',
          },
          ticks: {
            stepSize: 1,
            autoSkip: false,
            includeBounds: true,
            precision: 0,
            callback: (value, index, values) => {
              if (value === 0 && index === 0) return '0    ';
              return index % 5 === 0 ? value : '';
            },
            major: {
              enabled: true,
            },
            color: 'black',
            maxRotation: 0,
            minRotation: 0
          },
        },
        y: {
          min: 0,
          max: this.yMax,
          title: {
            display: true,
            text: 'THERMAL RESISTIVITY (°C -cm/W)',
          },
          ticks: {
            stepSize: 10,
            autoSkip: false,
            callback: (value, index, values) => {
              if (value === 0 && index === 0) return '';
              return index % 5 === 0 ? value : '';
            },
            major: {
              enabled: true,
            },
            color: 'black',
            maxRotation: 0,
            minRotation: 0
          },
        },
      },
    };
  }
}
